import type { AccommodationState } from '@/interfaces';
import { connect } from 'react-redux';
import { SearchFormPreview, type SearchFormPreviewProps } from '@/components/searchFormPreview/SearchFormPreview';
import { nameOverrides } from '@/utils/nameOverrides';

const mapStateToProps = (state: AccommodationState): SearchFormPreviewProps => {
    let destinationFullName =
        nameOverrides[state.filters.destination?.toLowerCase()] ||
        state.searchResults.destination?.fullName ||
        state.filters.destination?.replace(/_/g, ' ');
    if (state.filters.mapBounds) {
        destinationFullName = 'Kartutsnitt';
    } else if (!state.filters.destination && !state.filters.mapBounds) {
        destinationFullName = state.searchResults.searchConfig.title;
    }

    return {
        destinationFullName,
        checkInDate: state.filters.checkInDate,
        checkOutDate: state.filters.checkOutDate,
        rooms: state.filters.rooms,
    };
};

export default connect(mapStateToProps)(SearchFormPreview);
